/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Meta_Sign_InInputs */

const cs_auth_meta_sign_in = /** @type {(inputs: Auth_Meta_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlásit se přes Meta`)
};

const en_auth_meta_sign_in = /** @type {(inputs: Auth_Meta_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with Meta`)
};

/**
* | output |
* | --- |
* | "Sign in with Meta" |
*
* @param {Auth_Meta_Sign_InInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_meta_sign_in = /** @type {((inputs?: Auth_Meta_Sign_InInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Meta_Sign_InInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_meta_sign_in(inputs)
	return cs_auth_meta_sign_in(inputs)
});